export const TARGET_AUDIENCE_CODE = [
    {
        name: 'CEO/C-Suite',
        value: 0,
    },
    {
        name: 'VP-EVP',
        value: 1,
    },
    {
        name: 'SVP',
        value: 2,
    },
    {
        name: 'VP',
        value: 3,
    },
    {
        name: 'Sr Director',
        value: 4,
    },
    {
        name: 'Director',
        value: 5,
    },
    {
        name: 'Manager',
        value: 6,
    },
    {
        name: 'Business Owners',
        value: 7,
    },
    {
        name: 'Entrepreneurs',
        value: 8,
    },
    {
        name: 'Graducates',
        value: 9,
    },
    {
        name: 'Students',
        value: 10,
    },
    {
        name: 'Junior Manager',
        value: 11,
    }
]